export enum DialogTypes {
  ADDED = 'added',
  ORDER_CHANGE = 'order_change',
  PHOTO_CHANGE = 'photo_change',
  ORDER_PHOTO_CHANGE = 'order_photo_change',
}
